var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCountryFlags(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10386_116581)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.67773 11.5195C8.68185 11.5195 11.1172 9.08419 11.1172 6.08007C11.1172 3.07595 8.68185 0.640625 5.67773 0.640625C2.6736 0.640625 0.238281 3.07595 0.238281 6.08007C0.238281 9.08419 2.6736 11.5195 5.67773 11.5195Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.238281 6.08059C0.238281 8.41938 1.71441 10.4131 3.78576 11.1817V0.979492C1.71441 1.74803 0.238281 3.74184 0.238281 6.08059Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1178 6.08059C11.1178 3.74184 9.64166 1.74803 7.57031 0.979492V11.1817C9.64166 10.4131 11.1178 8.41938 11.1178 6.08059Z",
    fill: "#6DA544"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10386_116581"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.8789,
    height: 10.8789,
    fill: "white",
    transform: "translate(0.238281 0.640625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountryFlags);
export default __webpack_public_path__ + "static/media/Country Flags.e478e5468c8727794facbc84628da94f.svg";
export { ForwardRef as ReactComponent };